import React from "react";
import UnconfiguredComponent from '../common3/UnconfiguredComponent'
import styled from "styled-components"


const MessageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(220, 53, 69, 0.2);
  border: 1px solid #dc3545;
  border-radius: 10px;
  width: auto;
  margin-bottom: 20px;
`

const Message = styled.div`
  color: #dc3545;
  padding: 15px;
`


const Stop = (props) => {
  const { extra = {},builder = false } = props;
  const { next, prev, userMessage = "" } = extra;

  let hint= 'Will NOT prevent anything. Set behaviour in settings.'
  let  icon = 'fad fa-hand-paper'
  if( next && prev ) {
    hint = "Prevent next and previous"
  } else if ( next) {
    hint = "Prevent next"
  } else if ( prev) {
    hint = "Prevent previous"
  }

  return (
    <div>
      <UnconfiguredComponent icon={icon} label="Stop component" hint={hint}/>
      {userMessage && (
        <MessageWrapper className="sp-stop-text">
          <Message>{userMessage}</Message>
        </MessageWrapper>
      )}
    </div>
  )
};

export default Stop
